import React from "react";
import {AlertTooltip} from "./AlertTooltip";
import {PROPERTIES_FOR_METRIC} from "../../../metrics";
import { withTranslation } from 'react-i18next';

class GoalAlertTooltipClass extends AlertTooltip {
    render() {
        const { t } = this.props;
        let tooltipContent = this.tooltipContent();
        return (
            <div className="alert-tooltip">
                <div className="alert-tooltip-marker">
                    <i className="fa fa-circle" aria-hidden="true"/>
                </div>
                <div className="alert-tooltip-body">
                    <div className="alert-tooltip-header">
                        <div className="col-6 m-0 p-0"><p
                            className="alert-tooltip-title">{t('goal_alert_tooltip.goal')}
                            #{this.props.priority} {PROPERTIES_FOR_METRIC[this.props.metricName]["Spanish"]} = {this.props.formattedGoalValue}<span></span>
                        </p></div>
                        <div className="col-6 m-0 p-0 text-right"><span
                            className="font-weight-bold">{t('goal_alert_tooltip.day')}&nbsp;{this.props.dayNumber}{this.getTodayTitleText()}</span>
                        </div>

                    </div>
                    {tooltipContent}
                </div>
            </div>

        )
    }

    getFluctuationText() {
        const { t } = this.props;
        if (this.props.fluctuation === "up") {
            return t('goal_alert_tooltip.up');
        }

        if (this.props.fluctuation === "down") {
            return t('goal_alert_tooltip.down');
        }

        return "";
    }

    tooltipContent() {
        return (
            <div className="alert-tooltip-content">
                <p className="alert-tooltip-description">
                    {this.getTextUpMetricAccumulate()} <span
                    className={"-" + this.props.alertLevel + " font-weight-bold"}><br/>{this.props.fluctuationPercentage} {this.getFluctuationText()}</span><br/><br/>
                    <span style={{fontSize: "0.85em"}}>{PROPERTIES_FOR_METRIC[this.props.metricName]["Spanish"]} del día = {this.props.dayValue}.</span>
                    <div className={"conversions-by-action"}>{this.renderGoalConversionActions()}</div>
                </p>
            </div>
        );
    }

    getTodayTitleText() {
        const { t } = this.props;
        if (this.props.isToday) {
            return "    [ " + t('goal_alert_tooltip.today') + " ]"
        }
    }

    getTextUpMetricAccumulate() {
        const { t } = this.props;
        if (PROPERTIES_FOR_METRIC[this.props.metricName]['Accumulates']) {
            return <span>
                {t('goal_alert_tooltip.expected_value_at_period', { expectedValue: this.props.expectedValue, actualValue: this.props.value })}
            </span>;
        } else {
            return <span>
                {t('goal_alert_tooltip.goal_vs_actual', { goal: this.props.expectedValue, actual: this.props.value })}
            </span>;
        }
    }

    renderGoalConversionActions() {
        let all_details = []
        if (this.props.dayValueByType) {
            let details = []
            for (const [key, value] of Object.entries(this.props.dayValueByType)) {
                if(value !== null && value > 0)
                {
                    details.push(<span>- {key} : {typeof value === "number" ? value.toFixed(2) : value}</span>);
                    details.push(<br/>);
                }
            }
            if(details.length >0)
            {
                const { t } = this.props;
                all_details.push(<br/>);
                all_details.push(<span>{t('goal_alert_tooltip.day_conversions_detail', { dayNumber: this.props.dayNumber })}</span>);
                all_details.push(<br/>);
                all_details = all_details.concat(details)
            }
        }

        const adAccountsWithTextStatus = [];

        if (this.props.valueByType) {
            let details2 = []
            for (const [key, value] of Object.entries(this.props.valueByType)) {
                if(value !== null) {
                    if (value > 0) {
                        details2.push(<span>- {key} : {typeof value === "number" ? value.toFixed(2) : value}</span>);
                        details2.push(<br/>);
                    }

                    if (typeof value === 'string') {
                        const textValue = <span key={key}>- {key}: {value}<br/></span>;
                        adAccountsWithTextStatus.push(textValue);
                    }
                }
            }
            if(details2.length >0)
            {
                const { t } = this.props;
                all_details.push(<br/>);
                all_details.push(<br/>);
                all_details.push(<span>{t('goal_alert_tooltip.accumulated_conversions_detail')}</span>);
                all_details.push(<br/>);
                all_details = all_details.concat(details2)
            }

            if(adAccountsWithTextStatus.length >0) {
                const { t } = this.props;
                all_details.push(<br/>);
                all_details.push(<br/>);
                all_details.push(<span>{t('goal_alert_tooltip.clarifications')}</span>);
                all_details.push(<br/>);
                all_details = all_details.concat(adAccountsWithTextStatus)
            }
        }

        return all_details;
    }
}

export const GoalAlertTooltip = withTranslation()(GoalAlertTooltipClass);
export default GoalAlertTooltip;
